import { CropId, defineComponent, IParam } from "../omnia";

const winterCerealsCropN: IParam[] = [
    { text: "GAI 0.5", value: 15 },
    { text: "GAI 1.0", value: 30 },
    { text: "GAI 1.5", value: 45 },
];

const winterOilseedRapeCropN: IParam[] = [
    { text: "GAI 0.5", value: 25 },
    { text: "GAI 1.0", value: 50 },
    { text: "GAI 1.5", value: 75 },
    { text: "GAI 2.0", value: 100 },
    { text: "GAI 2.5", value: 125 },
    { text: "GAI 3.0", value: 150 },
];

export class AllocCropNCtrl {

    static create(): ng.IDirective {

        var def = defineComponent(AllocCropNCtrl, "app/soil/alloc/allocCropN.html", {
            "ngModel": "=",
            "cropId": "="
        });

        def.require = "ngModel";

        return def;

    };

    private _cropId: number;
    public values: IParam[];

    static $inject = ["$scope"];

    constructor(private $scope: ng.IScope) {
    }


    hasPredefinedValues(): boolean {
        return !!this.values;
    }

    get cropId(): number {
        return this._cropId;
    }

    set cropId(value: number) {

        this._cropId = value;

        switch (value) {

            case CropId.WinterWheat:
            case CropId.WinterBarley:
                this.values = winterCerealsCropN;
                break;

            case CropId.WinterOilseedRape:
                this.values = winterOilseedRapeCropN;
                break;

            default:
                this.values = null;

        }

    }

}

